//---------------------------------------------------Umaya

// import React, { useState, useEffect } from 'react';
// import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

// import PopularCars from '../components/PopularCars';
// import RecomandedCars from '../components/RecomandedCars';
// import './UserPage.css';
// import axios from 'axios';
// import backgroundImg from '../assets/IMG12.png';
// import UserPageHeader from '../components/UserPageHeader';

// const initialFilters = {
//   pickupLocation: '',
//   pickupDate: null,
//   pickupTime: null,
//   returnDate: null,
//   vehicleType: '',
//   travelType: '',
//   manufacturer: '',
//   capacity: ''
// };

// const UserPage = () => {
//   const [visibleDropdown, setVisibleDropdown] = useState(null);
//   const [selectedFilters, setSelectedFilters] = useState(initialFilters);
//   const [allCars, setAllCars] = useState([]);
//   const [popularCars, setPopularCars] = useState([]);
//   const [recommendedCars, setRecommendedCars] = useState([]);
//   const [filteredCars, setFilteredCars] = useState([]);
//   const [filterOptions, setFilterOptions] = useState({
//     manufacturers: [],
//     capacities: [],
//     travelTypes: [],
//     vehicleTypes: []
//   });
//   const [showAllPopularCars, setShowAllPopularCars] = useState(false);
//   const [showAllRecommendedCars, setShowAllRecommendedCars] = useState(false);
//   const [showAllSuitableCars, setShowAllSuitableCars] = useState(false);
//   const [showFilteredCars, setShowFilteredCars] = useState(false);
//   const [noResultsPopup, setNoResultsPopup] = useState(false);


//   useEffect(() => {
//     axios.get('https://carrentalbackend.dockyardsoftware.com/api/CarDetail/available-cars')
//       .then(response => {
//         const cars = response.data;
//         setAllCars(cars);

//         const availableCars = cars.filter(car => !car.isBooked);
//         extractFilterOptions(availableCars);

//         setPopularCars(availableCars.filter(car => car.isPopular));
//         setRecommendedCars(availableCars.filter(car => car.isRecommended));
//       })
//       .catch(error => console.error("Error fetching car data!", error));
//   }, []);

//   const extractFilterOptions = (cars) => {
//     setFilterOptions({
//       manufacturers: [...new Set(cars.map(car => car.manufacturer.name))],
//       capacities: [...new Set(cars.map(car => car.capacity))],
//       travelTypes: [...new Set(cars.map(car => car.travelType))],
//       vehicleTypes: [...new Set(cars.map(car => car.vehicleType))]
//     });
//   };

//   const handleFilterChange = (filterType, value) => {
//     setSelectedFilters(prev => ({ ...prev, [filterType]: value }));
//     setVisibleDropdown(null);
//   };

//   const handleDropdownToggle = (dropdownId) => {
//     setVisibleDropdown(prev => (prev === dropdownId ? null : dropdownId));
//   };

//   const handleSubmit = () => {
//     const filtered = allCars.filter(car => {
//       return (
//         (!selectedFilters.vehicleType || car.vehicleType === selectedFilters.vehicleType) &&
//         (!selectedFilters.manufacturer || car.manufacturer.name === selectedFilters.manufacturer) &&
//         (!selectedFilters.capacity || car.capacity === selectedFilters.capacity) &&
//         (!selectedFilters.travelType || car.travelType === selectedFilters.travelType)
//       );
//     });

//     if (filtered.length === 0) {
//       setNoResultsPopup(true); // 👈 Show popup if no cars match
//       return;
//     }

//     setFilteredCars(filtered);
//     setShowFilteredCars(true);
//   };


//   const handleShowAllPopularCars = () => {
//     setShowAllPopularCars(prev => !prev);
//   };

//   const handleShowAllRecommendedCars = () => {
//     setShowAllRecommendedCars(prev => !prev);
//   };

//   const handleShowAllSuitableCars = () => {
//     setShowAllSuitableCars(prev => !prev);
//   };

//   const handleRefresh = () => {
//     setSelectedFilters(initialFilters);
//     setFilteredCars([]);
//     setShowFilteredCars(false);
//     setVisibleDropdown(null);
//     setShowAllPopularCars(false);
//     setShowAllRecommendedCars(false);
//     setShowAllSuitableCars(false);
//   };

//   return (
//     <div className="min-h-screen p-5 bg-blue-200">
//       <UserPageHeader />

//       <div className="bg-white w-full mt-10 flex flex-wrap md:flex-row flex-col gap-4 items-start md:items-center px-4 py-3 shadow-md rounded-md md:rounded-full">
//         {[
//           { label: 'Vehicle Type', key: 'vehicleType', id: 6, list: filterOptions.vehicleTypes },
//           { label: 'Vehicle Manufacturer', key: 'manufacturer', id: 7, list: filterOptions.manufacturers },
//           { label: 'Vehicle Capacity', key: 'capacity', id: 8, list: filterOptions.capacities },
//           { label: 'Travel Type', key: 'travelType', id: 9, list: filterOptions.travelTypes }
//         ].map((item, idx) => (
//           <div key={idx} className="relative min-w-[150px] md:flex-1 text-xs w-full md:w-auto">
//             <div
//               onClick={() => handleDropdownToggle(item.id)}
//               className="flex justify-between items-center font-bold text-gray-700 px-3 py-1.5 rounded-lg cursor-pointer "
//             >
//               {/* {selectedFilters[item.key] || item.label} */}
//               <span className="text-gray-500 mr-1">{item.label}:</span>
//               <span className="text-black">{selectedFilters[item.key] || ''}</span>

//               {visibleDropdown === item.id ? <FaChevronUp /> : <FaChevronDown />}
//             </div>
//             <div className={`absolute left-0 top-full mt-1 w-full bg-white rounded-md shadow-lg z-20 ${visibleDropdown === item.id ? 'block' : 'hidden'}`}>
//               {item.list.map((val, i) => (
//                 <div
//                   key={i}
//                   className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
//                   onClick={() => handleFilterChange(item.key, val)}
//                 >
//                   {val}
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}

//         <div className="md:ml-auto w-full md:w-auto">
//           <button
//             onClick={handleRefresh}
//             className="bg-blue text-black px-4 py-1.5 rounded-full  text-sm w-full md:w-auto"
//           >
//             Refresh
//           </button>
//         </div>
//       </div>


//       {/* Submit Button */}
//       <div className="flex justify-center mt-4">
//         <button
//           onClick={handleSubmit}
//           className="bg-blue-500 text-white rounded-full py-2 px-10 text-sm hover:bg-blue-600"
//         >
//           Submit
//         </button>
//       </div>


//       <div className="text-image-container">
//         <div className="text-content">
//           <div className="text">
//             <div className="animated-text">The Best Platform for</div>
//             <div className="animated-text">Car Rental</div>
//           </div>
//           <div className="additional-text">
//             <div>Ease of doing a car rental safely and reliably. Of course </div>
//             <div>at a low price</div>
//           </div>
//         </div>
//         <img className="text-image" src={backgroundImg} alt="Car Rental" />
//       </div>
//       {noResultsPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded shadow-md text-center max-w-xs">
//             <h2 className="text-lg font-bold mb-2">No Cars Found</h2>
//             <p className="text-sm text-gray-700 mb-4">No cars matched your selected preference.</p>
//             <button
//               className="bg-blue-500 text-white px-4 py-1 rounded"
//               onClick={() => setNoResultsPopup(false)}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}


//       {/* Filtered Cars */}
//       {showFilteredCars && (
//         <>
//           <SectionHeader
//             title="Most Suitable Car"
//             onToggle={handleShowAllSuitableCars}
//             toggle={showAllSuitableCars}
//           />
//           <CarGrid cars={filteredCars} showAll={showAllSuitableCars} CardComponent={PopularCars} />

//         </>
//       )}
//       <>
//         <SectionHeader
//           title="Popular Car"
//           onToggle={handleShowAllPopularCars}
//           toggle={showAllPopularCars}
//         />
//         <CarGrid cars={popularCars} showAll={showAllPopularCars} CardComponent={PopularCars} />
//       </>

//       <>
//         <SectionHeader
//           title="Recommended Car"
//           onToggle={handleShowAllRecommendedCars}
//           toggle={showAllRecommendedCars}
//         />
//         <CarGrid cars={recommendedCars} showAll={showAllRecommendedCars} CardComponent={RecomandedCars} />
//       </>
//     </div>
//   );
// };

// // Section Header Reusable Component
// const SectionHeader = ({ title, onToggle, toggle }) => (
//   <div className="flex justify-between items-center mt-10">
//     <h2 className="text-sm font-bold text-blue ">{title}</h2>
//     <button onClick={onToggle} className=" font-medium">
//       {toggle ? 'View Less' : 'View All'}
//     </button>
//   </div>
// );

// const CarGrid = ({ cars, showAll, CardComponent }) => (
//   <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-4">
//     {cars.slice(0, showAll ? cars.length : 4).map((car, index) => (
//       <CardComponent key={index} data={car} />
//     ))}
//   </div>
// );

// export default UserPage;





//------------------------------------------------------------------Sachith---------------------------------------------------------------------------

 
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown, FaChevronUp, FaFilter, FaTimes, FaSearch, FaSyncAlt, FaStar } from 'react-icons/fa';
import PopularCars from '../components/PopularCars';
import RecomandedCars from '../components/RecomandedCars';
import UserPageHeader from '../components/UserPageHeader';
import axios from 'axios';
import backgroundImg from '../assets/IMG12.png';

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const initialFilters = {
  pickupLocation: '',
  pickupDate: null,
  pickupTime: null,
  returnDate: null,
  vehicleType: '',
  travelType: '',
  manufacturer: '',
  capacity: ''
};

const UserPage = () => {
  const [visibleDropdown, setVisibleDropdown] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(initialFilters);
  const [allCars, setAllCars] = useState([]);
  const [popularCars, setPopularCars] = useState([]);
  const [recommendedCars, setRecommendedCars] = useState([]);
  const [filteredCars, setFilteredCars] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    manufacturers: [],
    capacities: [],
    travelTypes: [],
    vehicleTypes: []
  });
  const [showAllPopularCars, setShowAllPopularCars] = useState(false);
  const [showAllRecommendedCars, setShowAllRecommendedCars] = useState(false);
  const [showAllSuitableCars, setShowAllSuitableCars] = useState(false);
  const [showFilteredCars, setShowFilteredCars] = useState(false);
  const [noResultsPopup, setNoResultsPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [heroLoaded, setHeroLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/available-cars`);
      const cars = response.data;
      console.log('Fetched cars:', cars); // Debug: Log fetched cars
      setAllCars(cars);

      const availableCars = cars.filter(car => !car.isBooked);
      console.log('Available cars:', availableCars); 
      extractFilterOptions(availableCars);

      const popular = availableCars.filter(car => car.isPopular);
      const recommended = availableCars.filter(car => car.isRecommended);
      console.log('Popular cars:', popular); // Debug: Log popular cars
      console.log('Recommended cars:', recommended); // Debug: Log recommended cars
      setPopularCars(popular);
      setRecommendedCars(recommended);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching car data!", error);
      setIsLoading(false);
    }
  };

  const loadMoreCars = async () => {
    try {
      const nextPage = page + 1;
      const response = await axios.get(`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/available-cars?page=${nextPage}`);
      const newCars = response.data;
      
      if (newCars.length === 0) {
        setHasMore(false);
        return;
      }
      
      setAllCars(prev => [...prev, ...newCars]);
      setPage(nextPage);
      
      const availableCars = [...allCars, ...newCars].filter(car => !car.isBooked);
      const popular = availableCars.filter(car => car.isPopular);
      const recommended = availableCars.filter(car => car.isRecommended);
      console.log('Updated popular cars:', popular);
      console.log('Updated recommended cars:', recommended);
      setPopularCars(popular);
      setRecommendedCars(recommended);
    } catch (error) {
      console.error("Error loading more cars", error);
    }
  };

  const extractFilterOptions = (cars) => {
    setFilterOptions({
      manufacturers: [...new Set(cars.map(car => car.manufacturer?.name || '').filter(Boolean))].sort(),
      capacities: [...new Set(cars.map(car => car.capacity))].sort(),
      travelTypes: [...new Set(cars.map(car => car.travelType))].sort(),
      vehicleTypes: [...new Set(cars.map(car => car.vehicleType))].sort()
    });
  };

  const handleFilterChange = (filterType, value) => {
    setSelectedFilters(prev => ({ ...prev, [filterType]: value }));
    setVisibleDropdown(null);
  };

  const handleDropdownToggle = (dropdownId) => {
    setVisibleDropdown(prev => (prev === dropdownId ? null : dropdownId));
  };

  const handleSubmit = () => {
    if (Object.values(selectedFilters).every(val => !val)) {
      setFilteredCars([]);
      setShowFilteredCars(false);
      return;
    }

    const filtered = allCars.filter(car => {
      return (
        (!selectedFilters.vehicleType || car.vehicleType === selectedFilters.vehicleType) &&
        (!selectedFilters.manufacturer || car.manufacturer?.name === selectedFilters.manufacturer) &&
        (!selectedFilters.capacity || car.capacity == selectedFilters.capacity) &&
        (!selectedFilters.travelType || car.travelType === selectedFilters.travelType)
      );
    });

    if (filtered.length === 0) {
      setNoResultsPopup(true);
      return;
    }

    setFilteredCars(filtered);
    setShowFilteredCars(true);
    
    setTimeout(() => {
      const results = document.getElementById('results-section');
      if (results) {
        window.scrollTo({
          top: results.offsetTop - 100,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const handleShowAllPopularCars = () => {
    console.log('Toggling showAllPopularCars:', !showAllPopularCars);  
    setShowAllPopularCars(prev => !prev);
  };

  const handleShowAllRecommendedCars = () => {
    console.log('Toggling showAllRecommendedCars:', !showAllRecommendedCars);  
    setShowAllRecommendedCars(prev => !prev);
  };

  const handleShowAllSuitableCars = () => {
    console.log('Toggling showAllSuitableCars:', !showAllSuitableCars);  
    setShowAllSuitableCars(prev => !prev);
  };

  const handleRefresh = () => {
    setSelectedFilters(initialFilters);
    setFilteredCars([]);
    setShowFilteredCars(false);
    setVisibleDropdown(null);
    setShowAllPopularCars(false);
    setShowAllRecommendedCars(false);
    setShowAllSuitableCars(false);
    setPage(1);
    setHasMore(true);
    fetchCars();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <UserPageHeader />
      
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800 text-white h-screen max-h-[1000px] min-h-[500px]">
        <motion.div 
          initial={{ scale: 1.2, opacity: 0 }}
          animate={{ scale: 1, opacity: 0.1 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0 bg-gradient-to-br from-yellow-400 to-transparent opacity-10 pointer-events-none"
        />
        
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(5)].map((_, i) => (
            <motion.div
              key={i}
              initial={{ y: -100, x: Math.random() * 100 - 50 }}
              animate={{ 
                y: window.innerHeight + 100,
                transition: {
                  duration: 10 + Math.random() * 10,
                  delay: Math.random() * 3,
                  repeat: Infinity,
                  repeatType: 'loop'
                }
              }}
              className="absolute top-0 h-2 w-2 rounded-full bg-white opacity-20"
              style={{ left: `${10 + (i * 20)}%` }}
            />
          ))}
        </div>

        <div className="container h-full mx-auto px-4 flex flex-col md:flex-row items-center justify-center relative z-10">
          <motion.div 
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="md:w-1/2 mb-12 md:mb-0 md:pr-8 pt-20 md:pt-0"
          >
            <motion.h1 
              variants={fadeInUp}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight mt-10 md:mt-0" 
            >
              The Best Platform for <br />
              <motion.span 
                className="text-yellow-300 inline-block"
                animate={{ 
                  scale: [1, 1.05, 1],
                  transition: { 
                    duration: 2,
                    repeat: Infinity,
                    repeatType: 'reverse'
                  }
                }}
              >
                Car Rental
              </motion.span>
            </motion.h1>
            
            <motion.p
              variants={fadeInUp}
              className="text-lg sm:text-xl md:text-2xl mb-8 max-w-lg leading-relaxed"
            >
              Ease of doing a car rental safely and reliably at the best prices in town.
            </motion.p>
            
            <motion.div variants={fadeInUp}>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold py-4 px-10 rounded-full shadow-lg transition-all duration-300 text-lg focus-visible:ring-2 focus-visible:ring-yellow-500 flex items-center"
                onClick={() => {
                  const filters = document.getElementById('filters');
                  window.scrollTo({
                    top: filters.offsetTop - 80,
                    behavior: 'smooth'
                  });
                }}
                aria-label="Rent a car now"
              >
                Rent Now
                <motion.span 
                  className="ml-2 inline-block"
                  animate={{
                    x: [0, 5, 0],
                    transition: {
                      duration: 1.5,
                      repeat: Infinity
                    }
                  }}
                >
                  🚗
                </motion.span>
              </motion.button>
            </motion.div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0, transition: { delay: 0.3, duration: 0.8 } }}
            className="md:w-1/2 flex items-center justify-center h-full"
            onLoad={() => setHeroLoaded(true)}
          >
            <motion.div 
              className="relative w-full max-w-8xl"
              animate={heroLoaded ? {
                y: [0, -15, 0],
                transition: {
                  duration: 4,
                  repeat: Infinity,
                  repeatType: 'reverse',
                  ease: 'easeInOut'
                }
              } : {}}
            >
              <img
                src={backgroundImg}
                alt="Luxury Car"
                className="w-full h-auto object-contain max-h-[70vh]"
                loading="eager"
                style={{ filter: 'drop-shadow(0 20px 30px rgba(0, 0, 0, 0.3))', transform: 'scale(1.1)' }}
              />
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: [0, 1, 0], transition: { delay: 1, duration: 3, repeat: Infinity } }}
                className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"
              />
            </motion.div>
          </motion.div>
        </div>

        <motion.div 
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
          animate={{ 
            y: [0, 10, 0],
            transition: { 
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }}
        >
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </motion.div>
      </div>

      {/* Filter Section */}
      <motion.section 
        id="filters"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, margin: "-100px" }}
        className="container mx-auto px-4 py-8 -mt-8 relative z-10"
      >
        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8">
          <div className="hidden md:grid grid-cols-1 md:grid-cols-5 gap-5 items-end">
            {[
              { label: 'Vehicle Type', key: 'vehicleType', list: filterOptions.vehicleTypes },
              { label: 'Manufacturer', key: 'manufacturer', list: filterOptions.manufacturers },
              { label: 'Capacity', key: 'capacity', list: filterOptions.capacities },
              { label: 'Travel Type', key: 'travelType', list: filterOptions.travelTypes }
            ].map((item, idx) => (
              <div key={idx} className="relative">
                <motion.label 
                  className="block text-sm font-medium text-gray-700 mb-2"
                  whileHover={{ color: '#3b82f6' }}
                >
                  {item.label}
                </motion.label>
                <motion.div
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => handleDropdownToggle(idx)}
                  className={`flex justify-between items-center w-full px-4 py-3 border rounded-xl cursor-pointer transition-all ${
                    selectedFilters[item.key] 
                      ? 'border-blue-500 bg-blue-50 shadow-inner' 
                      : 'border-gray-300 hover:border-blue-500'
                  }`}
                  role="button"
                  aria-expanded={visibleDropdown === idx}
                  aria-controls={`dropdown-${idx}`}
                >
                  <span className={`${
                    selectedFilters[item.key] ? 'text-gray-900 font-medium' : 'text-gray-500'
                  } truncate text-sm sm:text-base`}>
                    {selectedFilters[item.key] || `Select ${item.label}`}
                  </span>
                  {visibleDropdown === idx ? (
                    <FaChevronUp className="text-gray-500" />
                  ) : (
                    <FaChevronDown className="text-gray-500" />
                  )}
                </motion.div>
                <AnimatePresence>
                  {visibleDropdown === idx && (
                    <motion.div
                      id={`dropdown-${idx}`}
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.2 }}
                      className="absolute z-20 mt-1 w-full bg-white rounded-xl shadow-lg border border-gray-200 max-h-[50vh] overflow-auto"
                    >
                      {item.list.map((val, i) => (
                        <motion.div
                          key={i}
                          whileHover={{ backgroundColor: '#eff6ff' }}
                          className={`px-4 py-3 hover:bg-blue-50 cursor-pointer text-sm ${
                            selectedFilters[item.key] === val ? 'bg-blue-100 font-medium' : ''
                          }`}
                          onClick={() => handleFilterChange(item.key, val)}
                        >
                          {val}
                        </motion.div>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
            <div className="flex space-x-3">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition-all flex items-center justify-center space-x-2 flex-1 focus-visible:ring-2 focus-visible:ring-blue-500 shadow-md"
                aria-label="Search cars"
              >
                <FaSearch className="text-lg" />
                <span className="font-medium">Search</span>
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleRefresh}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-3 rounded-xl transition-all flex items-center justify-center space-x-2 focus-visible:ring-2 focus-visible:ring-gray-400 shadow-md"
                aria-label="Reset filters"
              >
                <FaSyncAlt className="text-lg" />
              </motion.button>
            </div>
          </div>

          <div className="md:hidden">
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() => setShowMobileFilters(!showMobileFilters)}
              className="flex items-center justify-center w-full bg-blue-600 text-white py-4 px-6 rounded-xl mb-4 space-x-3 focus-visible:ring-2 focus-visible:ring-blue-500 shadow-md"
              aria-label={showMobileFilters ? 'Hide filters' : 'Show filters'}
              aria-expanded={showMobileFilters}
            >
              <FaFilter className="text-lg" />
              <span className="font-medium">{showMobileFilters ? 'Hide Filters' : 'Show Filters'}</span>
            </motion.button>

            <AnimatePresence>
              {showMobileFilters && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="grid grid-cols-1 gap-4 mb-4">
                    {[
                      { label: 'Vehicle Type', key: 'vehicleType', list: filterOptions.vehicleTypes },
                      { label: 'Manufacturer', key: 'manufacturer', list: filterOptions.manufacturers },
                      { label: 'Capacity', key: 'capacity', list: filterOptions.capacities },
                      { label: 'Travel Type', key: 'travelType', list: filterOptions.travelTypes }
                    ].map((item, idx) => (
                      <div key={idx} className="relative">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {item.label}
                        </label>
                        <motion.div
                          whileTap={{ scale: 0.98 }}
                          onClick={() => handleDropdownToggle(idx)}
                          className={`flex justify-between items-center w-full px-4 py-3 border rounded-xl cursor-pointer transition-all ${
                            selectedFilters[item.key] 
                              ? 'border-blue-500 bg-blue-50 shadow-inner' 
                              : 'border-gray-300 hover:border-blue-500'
                          }`}
                          role="button"
                          aria-expanded={visibleDropdown === idx}
                          aria-controls={`dropdown-mobile-${idx}`}
                        >
                          <span className={`${
                            selectedFilters[item.key] ? 'text-gray-900 font-medium' : 'text-gray-500'
                          } truncate text-sm sm:text-base`}>
                            {selectedFilters[item.key] || `Select ${item.label}`}
                          </span>
                          {visibleDropdown === idx ? (
                            <FaChevronUp className="text-gray-500" />
                          ) : (
                            <FaChevronDown className="text-gray-500" />
                          )}
                        </motion.div>
                        <AnimatePresence>
                          {visibleDropdown === idx && (
                            <motion.div
                              id={`dropdown-mobile-${idx}`}
                              initial={{ opacity: 0, y: -10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -10 }}
                              transition={{ duration: 0.2 }}
                              className="absolute z-20 mt-1 w-full bg-white rounded-xl shadow-lg border border-gray-200 max-h-[50vh] overflow-auto"
                            >
                              {item.list.map((val, i) => (
                                <motion.div
                                  key={i}
                                  whileHover={{ backgroundColor: '#eff6ff' }}
                                  className={`px-4 py-3 hover:bg-blue-50 cursor-pointer text-sm ${
                                    selectedFilters[item.key] === val ? 'bg-blue-100 font-medium' : ''
                                  }`}
                                  onClick={() => handleFilterChange(item.key, val)}
                                >
                                  {val}
                                </motion.div>
                              ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    ))}
                  </div>
                  <div className="flex space-x-3">
                    <motion.button
                      whileTap={{ scale: 0.98 }}
                      onClick={handleSubmit}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition-all flex items-center justify-center space-x-2 flex-1 focus-visible:ring-2 focus-visible:ring-blue-500 shadow-md"
                      aria-label="Search cars"
                    >
                      <FaSearch className="text-lg" />
                      <span className="font-medium">Search</span>
                    </motion.button>
                    <motion.button
                      whileTap={{ scale: 0.95 }}
                      onClick={handleRefresh}
                      className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-3 rounded-xl transition-all flex items-center justify-center space-x-2 focus-visible:ring-2 focus-visible:ring-gray-400 shadow-md"
                      aria-label="Reset filters"
                    >
                      <FaSyncAlt className="text-lg" />
                    </motion.button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {Object.values(selectedFilters).some(Boolean) && (
            <motion.div 
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              transition={{ duration: 0.3 }}
              className="mt-4 flex flex-wrap gap-2"
            >
              {Object.entries(selectedFilters).map(([key, value]) => {
                if (!value) return null;
                const filterLabels = {
                  vehicleType: 'Type',
                  manufacturer: 'Brand',
                  capacity: 'Seats',
                  travelType: 'Travel'
                };
                return (
                  <motion.div 
                    key={key}
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="flex items-center bg-blue-100 text-blue-800 rounded-full px-3 py-1.5 text-sm font-medium shadow-sm"
                  >
                    <span>{filterLabels[key]}:</span>
                    <span className="mx-1">{value}</span>
                    <button 
                      onClick={() => handleFilterChange(key, '')}
                      className="text-blue-600 hover:text-blue-900 transition-colors ml-1"
                      aria-label={`Remove ${filterLabels[key]} filter`}
                    >
                      <FaTimes className="text-xs" />
                    </button>
                  </motion.div>
                );
              })}
            </motion.div>
          )}
        </div>
      </motion.section>

      <motion.section 
        id="results-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, margin: "-100px" }}
        className="container mx-auto px-4 py-12"
      >
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[...Array(4)].map((_, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0, transition: { delay: index * 0.1 } }}
                className="bg-white rounded-2xl shadow-md overflow-hidden"
              >
                <div className="h-56 bg-gradient-to-r from-gray-200 to-gray-300 animate-pulse"></div>
                <div className="p-5">
                  <div className="h-6 bg-gray-200 rounded-full w-3/4 mb-3"></div>
                  <div className="h-4 bg-gray-200 rounded-full w-1/2 mb-5"></div>
                  <div className="h-10 bg-gray-200 rounded-xl"></div>
                </div>
              </motion.div>
            ))}
          </div>
        ) : showFilteredCars ? (
          <>
            <SectionHeader
              title="Search Results"
              count={filteredCars.length}
              onToggle={handleShowAllSuitableCars}
              toggle={showAllSuitableCars}
            />
            <CarGrid cars={filteredCars} showAll={showAllSuitableCars} CardComponent={PopularCars} />
          </>
        ) : (
          <>
            {/* <SectionHeader
              title="Popular Cars"
              count={popularCars.length}
              onToggle={handleShowAllPopularCars}
              toggle={showAllPopularCars}
            />
            <CarGrid cars={popularCars} showAll={showAllPopularCars} CardComponent={PopularCars} />

            <SectionHeader
              title="Recommended Cars"
              count={recommendedCars.length}
              onToggle={handleShowAllRecommendedCars}
              toggle={showAllRecommendedCars}
            /> */}
            <div className="space-y-10">
  <div>
    <SectionHeader
      title="Popular Cars"
      count={popularCars.length}
      onToggle={handleShowAllPopularCars}
      toggle={showAllPopularCars}
    />
    <CarGrid cars={popularCars} showAll={showAllPopularCars} CardComponent={PopularCars} />
  </div>

  <div>
    <SectionHeader
      title="Recommended Cars"
      count={recommendedCars.length}
      onToggle={handleShowAllRecommendedCars}
      toggle={showAllRecommendedCars}
    />
    {/* <CarGrid cars={recommendedCars} showAll={showAllRecommendedCars} CardComponent={PopularCars} /> */}
  </div>
</div>

            <CarGrid cars={recommendedCars} showAll={showAllRecommendedCars} CardComponent={RecomandedCars} />

            {/* {hasMore && (
              <motion.button
                onClick={loadMoreCars}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="block bg-blue-600 text-white py-3 px-6 rounded-xl mt-10 mx-auto"
              >
                Load More Cars
              </motion.button>
            )} */}
          </>
        )}
      </motion.section>

      <AnimatePresence>
        {noResultsPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4 backdrop-blur-sm"
          >
            <motion.div
              initial={{ scale: 0.9, y: 20, opacity: 0 }}
              animate={{ scale: 1, y: 0, opacity: 1 }}
              exit={{ scale: 0.9, y: 20, opacity: 0 }}
              className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-full w-[90%] sm:max-w-md"
            >
              <div className="text-center">
                <motion.div 
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ type: 'spring', stiffness: 500, damping: 15 }}
                  className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-5"
                >
                  <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </motion.div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">No Cars Found</h3>
                <p className="text-sm text-gray-500 mb-6">
                  We couldn't find any cars matching your criteria. Please try different filters.
                </p>
                <div className="mt-5 flex justify-center space-x-4">
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    type="button"
                    className="inline-flex justify-center rounded-xl border border-gray-300 shadow-sm px-5 py-2.5 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400"
                    onClick={() => setNoResultsPopup(false)}
                    aria-label="Close no results modal"
                  >
                    Cancel
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    type="button"
                    className="inline-flex justify-center rounded-xl border border-transparent shadow-sm px-5 py-2.5 bg-blue-600 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                    onClick={() => {
                      setNoResultsPopup(false);
                      handleRefresh();
                    }}
                    aria-label="Reset filters"
                  >
                    Reset Filters
                  </motion.button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const SectionHeader = ({ title, count, onToggle, toggle }) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    viewport={{ once: true, margin: "-50px" }}
    className="flex justify-between items-center mb-8"
  >
    <div>
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h2>
      <p className="text-sm text-gray-500 mt-1">{count} {count === 1 ? 'car' : 'cars'} available</p>
    </div>
    
      {/* <motion.button 
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onToggle}
        className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center transition-colors focus-visible:ring-2 focus-visible:ring-blue-500 px-3 py-1.5 rounded-lg bg-blue-50"
        aria-label={toggle ? 'Show fewer cars' : 'Show all cars'}
      >
        {toggle ? 'Show Less' : 'View All'}
        {toggle ? (
          <FaChevronUp className="ml-2 text-xs" />
        ) : (
          <FaChevronDown className="ml-2 text-xs" />
        )}
      </motion.button> */}
    
  </motion.div>
);

const CarGrid = ({ cars, showAll, CardComponent }) => {
  console.log('CarGrid rendering:', { cars, showAll, cardCount: cars.length }); // Debug: Log CarGrid props
  return (
    <motion.div 
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      {cars.length === 0 ? (
        <div className="col-span-full text-center text-gray-500">
          No cars available in this category.
        </div>
      ) : (
        cars.slice(0, showAll ? cars.length : 4).map((car, index) => (
          <motion.div
            key={car.id || `car-${index}`}
            variants={fadeInUp}
            whileHover={{ y: -8 }}
            transition={{ type: 'spring', stiffness: 400, damping: 10 }}
            className="relative"
          >
            {car.isPopular && (
              <motion.div 
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.2 }}
                viewport={{ once: true }}
                className="absolute -top-3 -right-3 bg-yellow-400 text-yellow-900 rounded-full px-2 py-1 text-xs font-bold flex items-center z-10 shadow-md"
              >
                <FaStar className="mr-1" /> Popular
              </motion.div>
            )}
            <CardComponent data={car} />
          </motion.div>
        ))
      )}
    </motion.div>
  );
};

export default UserPage;